import { useDisclosure } from "@chakra-ui/react";
import { useState } from "react";
import { BiUserPlus } from "react-icons/bi";
import { Button } from "../../../components/ui/button";
import Workspace from "../../../components/workspace";
import UserForm from "./user-form";
import UsersListContainer from "./UsersListContainer";

const UserManagementPage = () => {
   const [searchQuery, setSearchQuery] = useState("");
   const formModal = useDisclosure();

   return (
      <>
         <UserForm modal={formModal} />
         <Workspace.TopBar heading="User Management" />
         <Workspace.WorkspaceActions>
            <Button variant="primary" onClick={formModal.onOpen}>
               <span className="inline-flex items-center gap-2">
                  <BiUserPlus className=" text-lg" />
                  Add new user
               </span>
            </Button>
         </Workspace.WorkspaceActions>
         <Workspace.ComponentWrapper>
            <Workspace.ListContainerHeader>
               <Workspace.HeaderPadding>
                  <Workspace.ListTitleWrapper>
                     <Workspace.ListTitle>Users</Workspace.ListTitle>
                     <Workspace.HeaderSearchWrapper>
                        <Workspace.HeaderSearchForm onSubmit={setSearchQuery} />
                     </Workspace.HeaderSearchWrapper>
                  </Workspace.ListTitleWrapper>
               </Workspace.HeaderPadding>
            </Workspace.ListContainerHeader>
            <UsersListContainer search={searchQuery} />
         </Workspace.ComponentWrapper>
      </>
   );
};

export default UserManagementPage;
